import axios from '@/js/plugins/client'
export default {
  alias      : 'persona',
  route      : '/tramite/persona',
  hash       : false,
  store      : false,
  key        : 'id',
  name       : 'nombre',
  selectable : false,
  default    : {
    id     : null,
    nombre : null,
  },  
  methods : {
    validarDNI(dni) {
      return new Promise((resolve, reject) => {
        console.log(dni)
        if (dni !== null && dni.length === 8) {
          axios.get(this.route +'/dni/'+dni).then(response => {
            if (!response.data.error) {
              resolve(response)
            } else {
              reject('DNI no encontrado en Padrón Electoral')
            }
          })
            .catch(()=>reject('DNI no encontrado en Padrón Electoral'))
        }else{
          reject('Ingrese un DNI valido (8 digitos)')
        }
      })
    },
    validarRUC(ruc) {
      return new Promise((resolve, reject) => {
        console.log(ruc)
        if (ruc !== null && ruc.length === 11) {
          axios.get(this.route +'/ruc/'+ruc).then(response => {
            resolve(response)
          })
            .catch(()=>reject('No se encontro el RUC'))
        }else{
          reject('Ingrese un RUC valido (11 digitos)')
        }
      })
    },
  }
}
  